export default __webpack_public_path__ + "static/media/02.703bdeb5.svg";